import { GeoKLocation } from '@app/shared/models/geo-k-location';
import { FilterRequest } from '@app/shared/models/filter';

export interface SelectLocationDialogComponentData {
  selectedLocations: GeoKLocation[];
  intialLocationsIds?: GeoKLocation[];
  filter?: LocationVerificationStatus;
  customFilters?: FilterRequest[];
  /**
   * When true (default), the dialog will limit the initial
   * fetched locations to the ones provided in `intialLocationsIds`.
   * When false, `intialLocationsIds` will only be used for pre-selection
   * but the user will be able to select additional locations.
   */
  limitToInitialLocations?: boolean;
  buttonLabel?: string;
  disableSubmitWhenEmpty?: boolean;
  singleSelection?: boolean;
  brandId?: string;
  title?: string;
  inViewMode: boolean;
  returnType: ModalReturnType;
  withNetwork?: boolean;
  channel?: string;
}

export enum ModalReturnType {
  GKLOCATION,
  ID,
}

export enum LocationVerificationStatus {
  ALL_GOOD = 'all-good',
  ALL = 'all',
  IN_REVIEW = 'in-review',
  BLOCKED = 'blocked',
}
